// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portal-grouped-list[data-v-6ea674bc]{max-width:100%}.v-subheader[data-v-6ea674bc]{height:100%!important}.v-list-item__title[data-v-6ea674bc]{white-space:normal!important}.noLink[data-v-6ea674bc]{text-decoration:none!important}", ""]);
// Exports
module.exports = exports;
